"use client";
import { db } from "../../firebase";
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  getDocs,
} from "firebase/firestore";
import useSWRSubscription from "swr/subscription";
import { isEqual } from "lodash";

export function useArchives(collectionName = "Archive") {
  const { data, error } = useSWRSubscription(
    [collectionName],
    ([path], { next }) => {
      let previousData = null;
      const ref = collection(db, path);
      const unsub = onSnapshot(
        ref,
        async (snaps) => {
          const archivesData = snaps.docs.map((doc) => ({
            id: doc.id,
            monthYear: doc.data().monthYear,
            ...doc.data(),
          }));
          // Only update if data has changed
          if (!isEqual(archivesData, previousData)) {
            next(null, archivesData);
            previousData = archivesData;
          }
        },
        (error) => {
          next(error?.message);
        }
      );
      return () => unsub();
    }
  );
  return {
    data,
    error,
    isLoading: data === undefined ? true : false,
  };
}

export const getArchive = async (id, monthYear, collectionName = "Archive") => {
  return await getDoc(doc(db, collectionName, id));
};
